export const AUTH = {
  emailInput: 'auth-email',
  passwordInput: 'auth-password',
  nameInput: 'auth-name',
  submitBtn: 'auth-submit',
  toRegister: 'auth-to-register',
  toLogin: 'auth-to-login',
};

export const ANALYSES = {
  createBtn: 'create-analysis-btn',
  historyTable: 'analyses-history-table',
  row: (id) => `analysis-row-${id}`,
  openBtn: (id) => `analysis-open-${id}`,
  duplicateBtn: (id) => `analysis-duplicate-${id}`,
  deleteBtn: (id) => `analysis-delete-${id}`,
  filterStatus: 'analyses-filter-status',
  filterSearch: 'analyses-filter-search',
};

export const WIZARD = {
  stepIndicator: (n) => `wizard-step-${n}`,
  nextBtn: 'wizard-next',
  prevBtn: 'wizard-prev',
  submitBtn: 'wizard-submit',
  scopeSelect: 'wizard-scope',
  stateSelect: 'wizard-state',
  muniCheckbox: (code) => `wizard-muni-${code}`,
  regionSelect: 'wizard-region',
  projectName: 'wizard-project-name',
  companyName: 'wizard-company-name',
  industry: 'wizard-industry',
  unitType: 'wizard-unit-type',
  avgTicket: 'wizard-ticket',
  investment: 'wizard-investment',
  minSales: 'wizard-min-sales',
  margin: 'wizard-margin',
  dependsTourism: 'wizard-depends-tourism',
  keywords: 'wizard-keywords',
  analysisName: 'wizard-analysis-name',
};

export const RESULT = {
  scoreValue: 'result-score-value',
  scoreCategory: 'result-score-category',
  downloadPdfBtn: 'result-download-pdf',
  duplicateBtn: 'result-duplicate',
  regenerateBtn: 'result-regenerate',
  indexCard: (key) => `index-card-${key}`,
  competitorRow: (i) => `competitor-row-${i}`,
  signalRow: (i) => `signal-row-${i}`,
  map: 'result-map',
};

export const ADMIN = {
  tabUsers: 'admin-tab-users',
  tabWeights: 'admin-tab-weights',
  tabSources: 'admin-tab-sources',
  tabUsage: 'admin-tab-usage',
  createUserBtn: 'admin-create-user',
  saveWeightsBtn: 'admin-save-weights',
  resetWeightsBtn: 'admin-reset-weights',
  weightSlider: (key) => `admin-weight-${key}`,
};
